import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuListItemSingleComponent } from './menu-list-item-single/menu-list-item-single.component';
import { ExpandableMenuComponent } from './expandable-menu/expandable-menu.component';
import { MenuButtonSingleComponent } from './menu-button-single/menu-button-single.component';
import { CustomMenuComponent } from './custom-menu/custom-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  declarations: [
    MenuListItemSingleComponent,
    ExpandableMenuComponent,
    MenuButtonSingleComponent,
    CustomMenuComponent,
  ],
  imports: [CommonModule, MatMenuModule, MatToolbarModule, MatIconModule, MatRippleModule],
  exports: [
    MenuListItemSingleComponent,
    ExpandableMenuComponent,
    MenuButtonSingleComponent,
    CustomMenuComponent,
  ],
})
export class MenuModule {}
